import { GridColumn } from 'types/grid';
import { ManageGridData } from 'types/manage';
import { ModalListData } from 'types/modal';
import { ListType } from 'types/selectbox';

//지상국 그리드 리스트
export const groundStationGridColumns: GridColumn[] = [
  { title: 'Name', key: 'name', width: 220 },
  { title: 'City', key: 'city', width: 180 },
  { title: 'Latitude', key: 'latitudeDegrees', width: 140 },
  { title: 'Longitude', key: 'longitudeDegrees', width: 140 },
  { title: 'Altitude (km)', key: 'altitudeMeters', width: 140 },
  { title: 'Provider', key: 'providerName', width: 140 },
  { title: 'Status', key: 'statusName', width: 160 },
  { title: '', key: 'viewDetails' }
];
// 지상국 상세보기 
export const manageModalList: ModalListData[] = [
  { title: 'Name', key: 'name' },
  { title: 'City', key: 'city' },
  { title: 'Latitude', key: 'latitude' },
  { title: 'Longitude', key: 'longitude' },
  { title: 'Altitude', key: 'altitude' },
  { title: 'Provider', key: 'provider' },
  { title: 'Status', key: 'statusName'},
  { title: 'AntennaVelocity', key: 'antennaVelocity'},
  { title: 'PointingAccuracy', key: 'pointingAccuracy'},
  { title: 'AntennaDiameter', key: 'antennaDiameter'},
  { title: 'Frequency', key: 'frequency'},
  { title: 'G/T', key: 'gtValue'},
  { title: 'Registered At', key: 'createdDate' },
];

export const statusList: ListType[] = [
  {value:1, label: 'Developing'},
  {value:2, label: 'Operating'},
  {value:3, label: 'Maintaining'},
];


export const groundStationGridData: ManageGridData[] = Array.from({ length: Math.round(Math.random() * 20) }, () => ({
  name: ['SEOUL', 'DAEJEON', 'DAEGU', 'GWANGJU'][Math.round(Math.random() * 3)] || 'DAEJEON',
  city: ['SEOUL', 'DAEJEON', 'DAEGU', 'GWANGJU'][Math.round(Math.random() * 3)] || 'DAEJEON',
  latitude: `${Math.round(Math.random() * 20 + 10)}º${Math.round(Math.random() * 20 + 10)}’${Math.round(Math.random() * 20 + 20)}”N`,
  longitude: `${Math.round(Math.random() * 20 + 10)}º${Math.round(Math.random() * 20 + 10)}’${Math.round(Math.random() * 20 + 20)}”E`,
  altitude: `${(Math.random() * 100).toFixed(2)}m`,
  provider: 'IOPS',
  status: 'In operation'
}));
